import { z } from "zod";

import { StrapiMediaSchema } from "./media.schema";

export const SeoSchema = z.object({
  id: z.number().int().positive(),
  title: z.string().optional(),
  description: z.string().optional(),
  keywords: z.string().optional(),
  ogImage: StrapiMediaSchema.optional(),
  schemaOrg: z.string().optional(),
});

export type Seo = z.infer<typeof SeoSchema>;
